<template>
  <div>
    <v-btn 
      v-for="timeChoice in timeChoices"
      :key="timeChoice" 
      outlined small
      style="border: none"
      @click="selectTime(timeChoice)"
    >
      {{ timeChoice }}
    </v-btn>
    <v-menu 
      offset-y 
      :close-on-content-click="false"
      v-model="datePickerActive"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          outlined
          v-on="on"
        >
          {{ dates[0]}} -> {{ dates[1]}}
        </v-btn>
      </template>
      <v-card>
        <!--<v-card-title class="headline">Unlimited music now</v-card-title>-->

        <v-card-text>
           <v-date-picker v-model="dates" range></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="datePickerActive=false">Close</v-btn>
        </v-card-actions>
        
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    data(){
      return {
        timeChoices : ['7D', 'PW', '30D','MTD', 'PM'],
        dates: [],
        datePickerActive: false
      }
    },
    created(){
      this.selectTime('7D')
    },
    methods: {
        selectTime(timeChoice){
          let dates = [];
          switch(timeChoice){
            case '7D':
              dates = [moment().subtract(7, 'days'), moment().subtract(1, 'days')]
              break
            case 'PW':
              dates[0] = moment().startOf('week').subtract(6, 'days')
              dates[1] =   moment().startOf('week')
              break
            case '30D':
              dates = [moment().subtract(30, 'days'), moment().subtract(1, 'days')]
              break
            case 'MTD':
              dates = [moment().startOf('month'), moment().subtract(1, 'days')]
              break
            case 'PM':
              dates = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
              break
          }
          this.dates = [dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD')]
        }
    },
    watch:{
      dates(){
        const dates = this.dates.map(x => x.replace(/-/g,''))
        this.$emit('datesUpdate',dates)
      }
    },
    computed:{
      
    }
  } 
</script>